import useSWR from "swr"
import useSWRMutation from "swr/mutation"
import { smithersClientService } from "@/services/smithers-client-service"
import type { CreateSmithersClientRequest } from "@/types/smithers-client"

export const SMITHERS_CLIENTS_KEY = ["smithers", "clients"]

export function useSmithersClients(enabled = true) {
  return useSWR(enabled ? SMITHERS_CLIENTS_KEY : null, () => smithersClientService.getAll(), {
    revalidateOnFocus: false,
    shouldRetryOnError: false,
  })
}

export function useCreateSmithersClient() {
  return useSWRMutation(SMITHERS_CLIENTS_KEY, (_key: string[], { arg }: { arg: CreateSmithersClientRequest }) => smithersClientService.create(arg))
}

export function useDeleteSmithersClient() {
  return useSWRMutation(SMITHERS_CLIENTS_KEY, (_key: string[], { arg }: { arg: number }) => smithersClientService.delete(arg))
}
